export default {
  general: {
    add: 'Aggiungi',
    all: 'Tutti',
    close: 'Chiudi',
    dateFormat: 'DD/MM/YYYY',
    apiDateFormat: 'YYYY-MM-DD',
    error: 'Si è verificato un errore',
    from: 'da',
    help: 'Aiuto',
    inactiveUser: 'Utenza non attiva. Chiedere ad un amministratore di attivarla',
    logoutOk: 'Logout completato',
    months: 'mesi',
    more: 'Più',
    next: 'Avanti',
    no: 'No',
    ok: 'Ok',
    campaignNotFound: {
      text: 'La campagna richiesta non è stata trovata.',
      link: 'Clicca qui per tornare alla lista'
    },
    pageNotFound: {
      text: 'La pagina richiesta non è stata trovata.',
      link: 'Clicca qui per tornare alla home'
    },
    sectionNotFound: {
      text: 'La sezione richiesta non è stata trovata.',
      link: 'Clicca qui per tornare alla prima sezione'
    },
    previous: 'Precedente',
    success: 'Operazione completata con successo',
    to: 'a',
    warning: 'warning',
    yes: 'Sì'
  },
  message: {
    activate: 'La campagna è stata attivata',
    create: 'Salvataggio completato',
    delete: 'Cancellazione completata',
    forbiddenActivation: 'Non è possibile creare una Data Extension dalla Business Unit corrente',
    update: 'Aggiornamento completato'
  },
  wizard: {
    step: {
      completed: 'Completato'
    }
  },
  action: {
    activate: 'Attiva',
    applyFilters: 'Applica filtri',
    back: '< Indietro',
    cancel: 'Cancel',
    clear: 'Cancella',
    continue: 'Continua',
    delete: 'Cancella',
    dismiss: 'Nascondi',
    downloadAsCsv: 'Scarica CSV',
    edit: 'Modifica',
    filter: 'Digita per filtrare',
    next: 'Avanti >',
    new: 'Nuovo',
    preview: 'Preview',
    publish: 'Pubblica',
    openDataExtension: 'Apri Data Extension',
    remove: 'Rimuovi',
    save: 'Salva',
    saveDraft: 'Salva Bozza',
    search: 'Cerca',
    upload: 'Carica File'
  },
  picklist: {
    values: '-- Selezionare un valore -- | 1 valore selezionato | {count} valori selezionati'
  },
  campaignDesigner: {
    campaignsList: {
      campaignName: 'Nome',
      campaignType: 'Tipo',
      createdDate: 'Data di creazione',
      createdBy: 'Creato da',
      deleteCampaign: 'Cancella campagna',
      deleteCampaignConfirm: 'Confermare la cancellazione della campagna?',
      endDate: 'Data di fine',
      fullCampaign: 'Campagna completa After Sales',
      headerCampaign: 'Solo testata After Sales',
      id: 'Id',
      newCampaign: 'Nuova Campagna',
      selectCampaignType: 'Selezionare un tipo di campagna',
      filters: 'Filtri',
      salesCampaign: 'Solo testata Sales',
      salesFullCampaign: 'Campagna completa Sales',
      startDate: 'Data di inizio',
      status: {
        label: 'Stato',
        Active: 'Attiva',
        Completed: 'Completata',
        Draft: 'Bozza',
        Inactive: 'Inattiva',
        'In Progress': 'In Corso'
      },
      type: {
        label: 'Tipo',
        'Commercial Campaign': 'Campagna Commerciale',
        'Contact Plan': 'Contact Plan'
      },
      tag: {
        label: 'Tag',
        Automotive: 'Automotive',
        Welcome: 'Welcome'
      },
      technicalCampaign: 'Tecnica'
    },
    campaignSetup: {
      acceptanceExpiringDate: 'Acceptance Expiring Date',
      alwaysOn: {
        label: 'Always On',
        tooltip: 'This flag controls daily target recalculation and orchestration (if enabled) for the whole campaign duration'
      },
      brand: 'Brand',
      brands: 'Brands',
      brandsAndModels: 'Brands and models selection',
      callTinyUrl: 'Call Tiny URL',
      campaignPullPush: {
        label: 'Campaign Pull / Push',
        1: 'Centrale',
        2: 'Centrale adesione dealer',
        3: 'Dealer'
      },
      ccdbReportEnabled: 'Esporta su CCDB',
      ccdbReportType: {
        label: 'CCDB Report Type',
        congratulations: 'Congratulations',
        standard: 'Standard'
      },
      channels: {
        label: 'Channels'
      },
      channel: 'Channel',
      codpack: 'Codpack',
      contentClassification: {
        label: 'Content Classification',
        All: 'All',
        MVP: 'MVP',
        Other: 'Other'
      },
      contributionType: {
        label: 'Contribution Type',
        Standard: 'Standard',
        Fleet: 'Fleet'
      },
      dealerCustomContacts: 'Dealer Custom Contacts',
      demOffer: 'DEM Offer',
      demTinyUrl: 'DEM Tiny URL',
      demTinyUrl1: 'DEM Tiny URL 1',
      demTinyUrl2: 'DEM Tiny URL 2',
      demTinyUrl3: 'DEM Tiny URL 3',
      demTinyUrl4: 'DEM Tiny URL 4',
      demTinyUrl5: 'DEM Tiny URL 5',
      description: 'Description',
      dmOffer: 'DM Offer',
      dmQRCode: 'DM QR Code',
      dmTinyUrl: 'DM Tiny Url',
      endDate: 'End Date',
      externalList: 'External List',
      htmlDescription: 'HTML Description',
      htmlDescriptionPreview: 'HTML Description Preview',
      imagePreviewUrl: 'Image Preview URL',
      parent: 'Parent',
      flagProvider: 'Flag Provider',
      fleetWarning: {
        title: 'Fleet',
        text: 'È stato selezionato un tipo di campagna Fleet. Ricorda di controllare le impostazioni di deduplica'
      },
      finality: {
        label: 'Finality',
        '1': 'Sales New',
        '2': 'Sales Used',
        '3': 'Aftersales',
        '4': 'Caring',
        '5': 'Nurturing Lead',
        '6': 'Win-back Indecisi SF',
        '7': 'Awareness',
        '8': 'Nurturing Permission',
        '9': 'Analisi / Conteggio',
        '10': 'Intervista',
        '11': 'Newsletter',
        '12': 'Data acquisition communication',
        '00': 'Loyalty',
        '99': 'Service Activity',
        tooltip: {
          afterSales: 'Use "Aftersales" and "Service Activity" to include the campaign in contribution evaluation',
          sales: 'Use "Sales New", "Nurturing Lead" and "Win-back Indecisi SF" to include the campaign in contribution evaluation'
        }
      },
      hierarchical: 'Hierarchical',
      manager: {
        label: 'Manager',
        dealer_fleet: 'Dealer Fleet',
        hq_fleet: 'HQ Fleet',
        HQ: 'HQ',
        Dealer: 'Dealer'
      },
      market: 'Market',
      masterKey: 'Campaign Masterkey',
      mediaCampaignId: 'Media Campaign ID',
      model: 'Model Code',
      modelCps: 'Model CPS',
      modelDescription: 'Model Description',
      name: 'Campaign Name',
      plannedSendDateDem: 'Planned Send Date DEM',
      plannedSendDateSMS: 'Planned Send Date SMS',
      providerElt: 'Provider ELT',
      relevantRedemption: 'Relevant Redemption',
      score: 'Score',
      seed: 'Seed',
      segmentType: {
        label: 'Segment Type',
        '15': 'LEAD',
        '16': 'PERMISSION',
        '17': 'CUSTOMER',
        '18': 'PROSPECT',
        '19': 'INDECISI SF',
        '20': 'PREVENTIVI',
        '21': 'LEAD <=6 MONTHS',
        '22': 'LEAD > 6 MONTHS',
        '23': 'AFTER SALES: CUSTOMER DI OFFICINA',
        '24': 'AFTER SALES: CUSTOMER FROM CCF',
        '25': 'AFTER SALES: PROSPECT GEOGRAFICO',
        '26': 'AFTER SALES: MOC REGISTRATION',
        '27': 'HANDRAISER',
        '28': 'ENTHUSIAST'
      },
      smsTinyUrl: 'SMS Tiny URL',
      smsOffer: 'SMS Offer',
      startDate: 'Start Date',
      targetSource: {
        label: 'Target Source',
        contacts: 'Only Contacts',
        contacts_leads: 'Contacts + Leads / Permissions'
      },
      thumbPreviewUrl: 'Thumb Preview URL',
      touchpoint: 'CP Touchpoint',
      type: {
        label: 'Campaign Type',
        'Contact Plan': 'Contact Plan',
        'Commercial Campaign': 'Commercial Campaign'
      },
      updatePreview: 'Update Preview',
      validation: {
        startDateMustBeInFuture: 'La data Data di inizio della campagna deve essere posteriore ad oggiP'
      }
    },
    contentSelection: {
      addTemplate: 'Add Template',
      campaign: 'Campaign',
      contactMonth: {
        label: 'Contact Month',
        tooltip: 'To be filled with "Months Year" (example: November 2020)'
      },
      chLevel1: 'CH Level 1',
      chLevel2: 'CH Level 2',
      chLevel3: 'CH Level 3',
      chLevel4: 'CH Level 4',
      chOffer: 'CH Offer',
      contactPlanCampaign: 'Contact Plan Campaign',
      deleteTemplate: 'Delete template',
      formatId: {
        label: 'Format Id'
      },
      htmlImg: 'HTML Image',
      htmlTemplate: 'HTML Template',
      htmlTemplatePreview: 'HTML Template Preview',
      messageCustom: 'Custom Message',
      prefix: 'Prefix',
      sender: 'Sender',
      template: 'Template',
      templateId: 'Template Id',
      templateName: 'Template Name',
      templateType: {
        label: 'Template Type',
        F: 'FCA',
        T: 'Dealer'
      },
      updateTemplate: 'Update preview',
      validation: {
        email: {
          required: 'At least one template is required for this channel'
        }
      }
    },
    targetDefinition: {
      addEngagementCondition: 'Add Condition',
      addRule: 'Regola',
      addRuleGroup: 'Gruppo',
      associatedDealer: 'Associated Dealer',
      applyToOtherSections: 'Apply to other sections',
      channel: 'Channel',
      clear: 'Svuota',
      brand: 'Brand',
      brandTypes: {
        label: 'Brand Types'
      },
      carAge: 'Car Age',
      carFilterType: 'Car Filter Type',
      carsWithoutWarranties: 'Cars without warranties',
      clientType: {
        label: 'Client Type',
        P: 'Private',
        C: 'Company',
        U: 'Undefined'
      },
      communicationChannelsFilterLogic: {
        label: 'Communication Channels filter logic',
        AND: 'Match all criteria',
        OR: 'Match at least one'
      },
      communicationsNumber: {
        label: 'Number of communication in last days'
      },
      confirmFilterDisableTitle: 'Confirm element removal',
      confirmFilterDisableText: 'Element removed cannot be added back. Do you want to remove it?',
      contactPlan: 'Contact Plan',
      contentFilters: 'Content Filters',
      contracts: 'Contracts',
      cpTypeTargetSelection: 'CP-TYPE Target Selection',
      customerFilters: 'Customer Filters',
      dealerCluster: {
        label: 'Dealer Cluster',
        tooltip: 'Only those customer-vehicle for whom a dealer can be associated will be eligible'
      },
      deduplication: {
        label: 'Deduplication',
        deduplication: 'Select Deduplication Criteria',
        sorting: 'Select Sorting Criteria',
        nearest: 'The VIN with the nearest First Reg. Date',
        oldest: 'The VIN with the oldest First Reg. Date',
        mostRecent: 'The VIN with the most recent Workshop Visit'
      },
      disableOrchestration: 'Disable Orchestration',
      downloadTemplate: 'Download template',
      elapsedTimeBetweenLastTwoVisits: {
        label: 'Workshop visit Elapsed Time',
        tooltip: 'Less than 30 days must have passed between the last visit and the previous'
      },
      engagement: {
        label: 'Engagement',
        'RED': 'Disengaged (Red)',
        'GREEN': 'Engaged (Green)',
        'YELLOW': 'Alive (Yellow)',
        tooltip: `Engagement – How is engaged with the communications sent on a specific channel.
          The Engagement Index is applicable to all the customers and starts with the first communication sent to him/her.
          The nurturing communications do not contribute to the E.I. calculation.`
      },
      engagementIndex: 'Email Engagement Index',
      engineSize: 'Engine Size',
      excludeContactsWithoutAssociatedDealer: 'Exclude Contacts Without Associated Dealer',
      excludedMVS: 'Excluded MVS',
      excludedVIN: 'Excluded VIN ({count})',
      field: {
        'birthdate::date': 'Birthdate',
        'ccf_date::date': 'CCF Date',
        'd_opt_in_email_date::date': 'Email Opt-in Date',
        'first_reg_date::date': 'First Registration Date',
        'last_ocf_date::date': 'Last OCF Date',
        'lead_date::date': 'Lead Date',
        'ocf_date::date': 'OCF Date',
        'perm_date::date': 'Permission Date',
        'purchase_date::date': 'Purchase Date',
        'quote_date::date': 'Quote Date',
        address: 'Address',
        brand: 'Brand',
        business_area: 'Business Area',
        city: 'City',
        cod_market: 'Market',
        contact_plan_disabled: 'Contact Plan Disabled',
        cta: 'CTA',
        customer_status: 'Customer Status',
        d_opt_in_email: 'Email Opt-in',
        doubleOptIn: 'Double Opt In',
        email_service: 'Email service',
        email: 'Email address',
        flag_owner: 'Flag Owner',
        flag_vat: 'Flag VAT',
        gender: 'Gender',
        has_car_total_lpmi: 'Has Car Total LPMI',
        id_campaign: 'ID Campaign',
        id_offer: 'ID Offer',
        label: 'Attribute',
        level1: 'Level1',
        level2: 'Level2',
        level3: 'Level3',
        level4: 'Level4',
        lp_model: 'LP Model',
        markedAsHardBounceback: 'Marked as Hard Bounceback',
        market_segment: 'Market Segment',
        mobile_number_service: 'Mobile Number Service',
        mobile_number: 'Mobile Number',
        model: 'Model',
        mvs_external_id: 'MVS External Id',
        onlyDealerEmail: 'Only Dealer Email flag',
        outbound_leapmotor: 'Outbound Leapmotor',
        outbound_others: 'Outbound Others',
        outbound_total: 'Outbound Total',
        ownership_type: 'Ownership Type',
        party_type: 'Client Type',
        phone_number: 'Phone Number',
        pref_contact_code: 'Pref Contact Code',
        preferred_language: 'Preferred Language',
        privacy_email: 'Privacy Email',
        privacy_mail: 'Privacy Mail',
        privacy_tel: 'Privacy Phone',
        privacy_sms: 'Privacy SMS',
        province: 'Province',
        quote_mvs_external_id: 'Quote MVS External Id',
        record_validity: 'Record Validity',
        stato: 'Stato',
        zip_code: 'ZIP Code'
      },
      firstRegistrationDate: 'First Registration Date',
      fleet: {
        label: 'Fleet',
        tooltip: `This filter allows the user to include or exlude at coupons generation vehicles and customers that satisfy all the following conditions:
          1) Vehicles classified as Fleet
          2) Customers with Small or Medium Fleet Park
          3) Vehicles and Customers not LTR
          4) Vehicles sold as Indirect and Customer with only Indirect vehicles in park
          5) Customer not matched with a Customer on Salesforce
          6) Leapmotor <vehicleName> vehicles will be excluded from the target (model 620, versions QRU and QRV)
          7) Only for France: customers with a Fleet park of 9 vehicles maximum (<10)
        `
      },
      fuelTypes: {
        label: 'Fuel Type',
        CMBBE: 'Electric / Gasoline',
        CMBBG: 'Gasoline / LPG',
        CMBBM: 'Gasoline / NCG',
        CMBBZ: 'Gasoline',
        CMBDS: 'Diesel',
        CMBEL: 'Electric',
        CMBMT: 'Methane',
        ELECTRIC: 'Electric'
      },
      gender: {
        label: 'Gender',
        M: 'Male',
        F: 'Female'
      },
      includedMVS: 'Included MVS',
      includedVIN: 'Included VIN ({count})',
      lastUpdateDateIsLastWSVisit: {
        label: 'Updates from the last Workshop',
        tooltip: 'The last update date must correspond to the last workshop visit'
      },
      manageDealers: 'Manage Dealers',
      manageMVS: 'Manage MVS',
      manageVIN: 'Manage VIN',
      manageZipCodes: {
        label: 'Manage ZIP Codes',
        invalidZipCodesWarning: 'Warning: ZIP Codes not valid',
        invalidZipCodesWarningText: 'Following Markets - ZIP Codes are not valid: <ul>{list}</ul>'
      },
      market: {
        label: 'Market',
        ITA: 'Italy',
        FRA: 'France',
        USA: 'USA',
        JAP: 'Japan',
        ESP: 'Spain',
        CH: 'Switzerland'
      },
      marketingPrivacyConsent: 'Marketing Privacy Consent',
      mileages: 'Mileage (km)',
      mileageTag: {
        label: 'Mileage Tag',
        H: 'High',
        M: 'Medium',
        L: 'Low'
      },
      maintenanceModelCluster: 'Vehicle Maintenance Model Cluster',
      manageMvsVin: 'Manage MVS / VIN',
      mileageTagAvailable: 'Mileage TAG Available',
      mmaAvailable: 'MMA available',
      modelYearFrom: 'Model Year From',
      monthsFromFirstRegistrationDate: 'Months from First registration date',
      mvs: 'MVS',
      mvsNotFoundWarning: 'Warning: MVS not found',
      mvsNotFoundWarningText: 'Following MVS have not been found: <ul>{list}</ul>',
      ocfDate: 'OCF Date',
      pressure: {
        label: 'Pressure',
        P1: '1 - 2 contacts (P1)',
        P2: '3 - 6 contacts (P2)',
        P3: '7 - 12 contacts (P3)',
        P4: '13 - 24 contacts (P4)',
        P5: '> 24 contacts (P5)'
      },
      preview: 'Preview Filtri',
      profilingPrivacyConsent: 'Profiling Privacy Consent',
      purchasedServicesAndAccessories: 'Purchased services and accessories',
      rangeSelector: 'Range Selector',
      reactivity: {
        label: 'Reactivity',
        R0: 'No open (R0)',
        R1: '0 - 3 days (R1)',
        R2: '4 - 10 days (R2)',
        R3: '> 10 days (R3)',
        tooltip: `Average time taken by the customer for interacting (e.g. opening, clicking) with the communications received.
          The Index is calculated on a specific number of communications received: from 1 up to 5.`
      },
      registrationOnMOC: 'Registration on MOC',
      rulesAlert: 'Le regole relative a Brand, Mercato e Canali sono già state importate dal Campaign Setup',
      saveGroupAs: 'Salva Gruppo come...',
      saveSectionAs: 'Salva Filtri come...',
      selectBrands: 'Select at least one brand to select MVS',
      status: 'Status',
      segment: 'Segment',
      segments: 'Filtri',
      deletePreview: 'Elimina Preview',
      deletePreviewConfirm: 'Sei sicuro di voler eliminare questa preview?',
      segmentName: 'Nome',
      standardSegment: 'Da Campaign Setup',
      table: {
        label: 'Entity',
        contact: 'Contact',
        lead: 'Lead',
        perm: 'Permission',
        ocf: 'OCF',
        quote: 'Quote'
      },
      targetCluster: {
        label: 'Target Cluster',
        'at risk': 'At Risk',
        beginner: 'Beginner',
        loyal: 'Loyal',
        lost: 'Lost'
      },
      targetRange: {
        label: 'Target Range'
      },
      touchpointSelection: 'Touchpoint Selection',
      uploadCsv: 'Upload CSV',
      uploadVINToExclude: 'Upload VIN to exclude',
      validation: {
        missingOperator: 'Specificare una condizione',
        missingRuleOrGroup: 'Inserire una regola o un gruppo di regole',
        oneConditionRequired: 'Per questa condizione è obbligatoria una regola',
        twoOrMoreConditionsRequired: 'Per questa condizione sono richieste almeno due regole'
      },
      vehicleTypes: {
        label: 'Vehicle Type',
        CABRIO: 'Cabrio',
        CITYCAR: 'City car',
        ECO: 'Eco',
        HYBRID: 'Hybrid',
        SUV: 'SUV'
      },
      viewMVS: 'View MVS',
      viewVIN: 'View VIN',
      vin: 'VIN',
      warrantyExtension: 'Warranty Extension',
      workshopVisitsWithSameMileageTagNumber: {
        label: 'Associated Mileage tag confirmed',
        tooltip: 'The customer must have performed two or more workshop visits in which the same mileage tags were associated'
      },
      zipCode: 'ZIP Code'
    },
    contentSelectionAndTag: {
      brand: 'Brand',
      carAge: 'Car Age',
      churnScore: 'Churn Score',
      contentPriority: {
        label: 'Content Priority*',
        primary: 'Primary',
        secondary: 'Secondary',
        tertiary: 'Tertiary'
      },
      contentSetting: 'Content Setting',
      date: 'Date',
      description: 'Description*',
      downloadCsv: 'Download as CSV',
      endDate: 'End Date',
      excludeVin: 'Excluded VIN ({count})',
      flatOffer: 'Offer',
      fleet: 'Fleet',
      includeVin: 'Included VIN ({count})',
      insertNewContent: 'Nuovo contenuto',
      itemTypeDescription: 'Item',
      itemDescription: 'Item Description',
      kmFrom: 'Km From',
      kmTo: 'Km To',
      masterKey: 'MasterKey',
      monthAge: 'Model Age',
      mvsList: 'MVS List',
      mvs: 'MVS',
      mvsTabLabel: 'MVS ({count})',
      name: 'Offer Type',
      offerType: 'Offer Type',
      onlyInformativeCampaign: 'Only informative campaign',
      quantity: 'Quantity',
      offer: 'Offer',
      offerSelection: 'Offer Selection',
      priceValue: 'Value',
      startDate: 'Start Date',
      status: 'Status',
      tag: 'Tag*',
      touchPoint: 'TouchPoint',
      validate: {
        insertContent: 'For this campaign type at least one content is required',
        insertOffer: 'For this campaign type at least one offer is required'
      },
      vinList: 'VIN List',
      vinMvsList: 'VIN / MVS List',
      vin: 'VIN'
    },
    finalCheckAndCampaignRelease: {
      brand: 'Brand',
      channel: 'Channel',
      channelPriority: 'Channels Priority',
      computePreview: 'Avvia calcolo Preview',
      computingPreview: 'Calcolo Preview in corso...',
      contactCount: 'Tot. Contatti',
      emptyPreview: 'Nessun contatto è stato estratto dalla preview',
      numberOfContacts: '# Contatti',
      numberOfContactsEmailGranted: '# Contatti Email Granted',
      numberOfContactsSmsGranted: '# Contatti SMS Granted',
      numberOfCars: '# Cars',
      numberOfDistinctEmail: '# Distinte Email',
      numberOfDistinctSMS: '# Distinti SMS',
      leadType: {
        label: 'Tipo Lead',
        lead: 'Lead',
        perm: 'Permission'
      },
      previewError: 'Si è verificato un errore durante il calcolo della Preview',
      status: 'Status'
    },
    confirmActivation: {
      as_app_delivery: {
        title: 'Attivazione campagna App Delivery',
        text: 'Attivando questa campagna tutte le altre campagne App Delivery verranno disattivate. Confermare l\'attivazione?'
      },
      as_rfid: {
        title: 'Attivazione campagna RFID',
        text: 'Attivando questa campagna tutte le altre campagne RFID verranno disattivate. Confermare l\'attivazione?'
      },
      sr_app_delivery: {
        title: 'Attivazione campagna App Delivery',
        text: 'Attivando questa campagna tutte le altre campagne App Delivery verranno disattivate. Confermare l\'attivazione?'
      },
      sr_rfid: {
        title: 'Attivazione campagna RFID',
        text: 'Attivando questa campagna tutte le altre campagne RFID verranno disattivate. Confermare l\'attivazione?'
      },
      standard: {
        title: 'Attivazione campagna',
        text: 'Una volta attivata, questa campagna verrà immediatamente orchestrata. Confermare l\'attivazione?'
      }
    },
    confirmPageLeaveText: 'Sono presenti modifiche che verranno perse. Uscire dalla pagina?',
    createCampaign: 'Crea Campagna',
    editCampaign: 'Modifica Campagna',
    viewCampaign: 'Visualizza Campagna',
    newCampaign: 'Nuova Campagna'
  },
  executionRules: {
    exclusionRules: {
      calendar: {
        label: 'Calendario',
        CC: 'CC'
      },
      country: 'Paese',
      market: 'Mercato',
      selectCalendar: 'Selezionare un Calendario',
      selectMarketOrCountry: 'Selezionare un Mercato/Paese',
      today: 'Oggi',
      viewMode: {
        daily: 'Giorno',
        monthly: 'Mese',
        weekly: 'Settimana',
        yearly: 'Anno'
      }
    },
    sendingRules: {
      calendar: {
        label: 'Calendario',
        CC: 'CC'
      },
      channel: 'Canale',
      market: 'Mercato',
      maxCommsMonth: 'Numero massimo di comunicazioni al mese',
      maxCommsWeek: 'Numero massimo di comunicazioni alla settimana',
      minDaysBetweenComms: 'Numero minimo di giorni tra le comunicazioni',
      selectMarketAndChannel: 'Selezionare un Mercato/Paese e un Canale',
      modal: {
        addSlot: 'Aggiungi Slot',
        editSlot: 'Modifca Slot',
        inclusionDay: 'Giorno',
        sendStartHour: 'Ora inizio',
        sendEndHour: 'Ora fine'
      }
    }
  },
  jobsViewer: {
    title: 'Jobs'
  },
  usersManagement: {
    editUser: 'Modifica informazioni utente',
    users: 'Utenti',
    filters: {
      active: {
        'true': 'Attivo',
        'false': 'Inattivo'
      },
      status: {
        all: 'Tutti',
        label: 'Stato'
      }
    },
    user: {
      active: 'Attivo',
      countries: 'Mercati',
      email: 'Email',
      name: 'Nome completo',
      role: 'Ruolo',
      roles: {
        ADMINISTRATOR: 'Administrator',
        CHANNEL_MANAGER: 'Channel Manager',
        CONTENT_EDITOR_PUBLISHER: 'Content Editor / Publisher',
        SECURITY_ADMINISTRATOR: 'Security Administrator',
        VIEWER: 'Viewer'
      },
      visibility: 'Visibilità',
      sfmcId: 'Salesforce ID',
      sub: 'Salesforce ID',
      locale: 'Lingua locale'
    },
    deleteUser: 'Rimuovi Utente',
    deleteUserConfirm: 'Sicuro di voler rimuovere l\'utente?',
    deleteSuccess: 'Utente rimosso correttamente',
    deleteError: 'Errore: non è stato possibile rimuovere l\'utente',
    createSuccess: 'Utente creato correttamente',
    createError: 'Errore: non è stato possibile creare l\'utente',
    updateSuccess: 'Utente aggiornato correttamente',
    updateError: 'Errore: non è stato possibile aggiornare l\'utente',
    newUser: 'Nuovo utente'
  },
  sections: {
    navigation: 'Navigazione',
    administration: 'Amministrazione',
    campaignDesigner: 'Campaign Designer',
    campaignMonitoring: 'Campaign Monitoring',
    contentSelection: 'Content Selection',
    customization: 'Personalizzazione',
    userManagement: 'Gestione Utenti',
    executionRules: {
      label: 'Regole di Esecuzione',
      exclusionRules: {
        label: 'Regole di Esclusione'
      },
      sendingRules: {
        label: 'Regole di invio'
      }
    },
    campaignSetup: 'Campaign Setup',
    targetDefinition: 'Target Definition',
    contentSelectionAndTag: 'Content Selection & Tag',
    finalCheckAndCampaignRelease: 'Final Check & Campaign Release',
    settings: 'Impostazioni',
    home: 'Home',
    cleanIt: 'Clean IT',
    offerViewer: 'Offer Viewer',
    previewSetup: 'Preview Setup',
    preview: 'Preview'
  },
  locales: {
    gb: 'Inglese',
    it: 'Italiano'
  },
  setting: {
    locale: 'Lingua'
  },
  validation: {
    biggerOrEqualThan: 'Il valore non può essere inferiore al massimo consentito ({maxValue})',
    custom: {
      addAtLeastOneBrand: 'Per questo tipo di campagna è necessario specificare almeno una coppia brand / modello',
      atLeastOneFilterIsRequired: 'Impostare almeno un filtro tra Engagement conditions e Months from First Registration date',
      conditionalRequiredUserManagement: 'È necessario speciifcare almeno un mercato per un utente attivo',
      endDateExceed: 'La Data di fine non può essere posteriore alla Data di fine dell\'offerta',
      invalidZipCodeForMarket: 'Zip Code non valido per questo mercato',
      startDateExceed: 'La Data di inizio non può essere antecedente alla Data di inizio dell\'offerta'
    },
    dateAfter: 'Data non valida',
    dateAfterToday: 'Data non valida: la data deve essere posteriore ad oggi',
    dateBefore: 'La Data di inizio deve essere antecedente alla Data di fine',
    duplicateRange: 'Range duplicato',
    duplicateValue: 'Valore già presente',
    email: 'Formato non valido',
    hour: 'Formato non valido',
    hourBefore: 'L\'ora inizio deve essere antecedente all\'Ora fine',
    invalidData: 'Errore: dati non validi',
    invalidDataMessage: 'Verifica tutti i messaggi sotto per correggere i dati',
    isInRange: 'I valori non possono superare quelli dell\'offerta',
    lessOrEqualThan: 'Il valore non può superare il massimo consentito ({maxValue})',
    maxLength: 'La lunghezza del testo non può superare il massimo consentito ({maxValue})',
    positiveNumber: 'Formato non valido',
    required: 'Campo richiesto',
    rangeMismatch: '"From" must be lower than "to"',
    url: 'Invalid format',
    year: 'Invalid year format'
  },
  months: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Augosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre'
  ],
  days: {
    eng: {
      short: {
        MON: 'LUN',
        TUE: 'MAR',
        WED: 'MER',
        THU: 'GIO',
        FRI: 'VEN',
        SAT: 'SAB',
        SUN: 'DOM'
      },
      long: {
        MON: 'Lunedì',
        TUE: 'Martedì',
        WED: 'Mercoledì',
        THU: 'Giovedì',
        FRI: 'Venerdì',
        SAT: 'Sabato',
        SUN: 'Domenica'
      }
    },
    short: [
      'Lun',
      'Mar',
      'Mer',
      'Gio',
      'Ven',
      'Sab',
      'Dom'
    ],
    long: [
      'Lunedì',
      'Martedì',
      'Mercoledì',
      'Giovedì',
      'Venerdì',
      'Sabato',
      'Domenica'
    ]
  },
  brands: {
    All: 'Multibrand',
    leapmotor: 'LEAPMOTOR',
    '082': 'LEAPMOTOR'
  },
  channels: {
    cross: 'Cross',
    email: 'Email',
    sms: 'SMS'
  },
  consent: {
    'Y': 'Sì',
    'N': 'No',
    'noFilter': 'Nessun filtro'
  },
  countries: {
    DEU: 'Germania',
    ESP: 'Spagna',
    FRA: 'Francia',
    ITA: 'Italia',
    USA: 'Stati Uniti'
  },
  markets: {
    '8801': 'Italy',
    '8811': 'Austria',
    '8806': 'Belgio',
    '8802': 'Francia',
    '8803': 'Germania',
    '8805': 'Regno Unito',
    '8808': 'Olanda',
    '8810': 'Polonia',
    '8804': 'Spagna',
    '8809': 'Portogallo'
  },
  filters: {
    exclude: 'Escludi',
    include: 'Inclusi',
    noFilter: 'Nessun filtro',
    carAge: {
      touchpoint: 'Touchpoint',
      date: 'Data',
      age: 'Età'
    }
  },
  notification: {
    PREVIEW_COMPUTED: {
      title: '{campaignId} - Fine generazione Preview',
      text: 'La Preview per la campagna {campaignId} è stata generata!'
    },
    PREVIEW_ERROR: {
      title: '{campaignId} - Fine generazione Preview',
      text: 'La generazione della Preview per la campagna {campaignId} è terminata con un errore'
    },
    TARGET_COMPUTED: {
      title: '{campaignId} - Fine generazione Target',
      text: 'Il Target per la campagna {campaignId} è stato generato!'
    },
    TARGET_ERROR: {
      title: '{campaignId} - Fine generazione Target',
      text: 'La generazione del Target per la campagna {campaignId} è terminata con un errore'
    },
    SEED_TARGET_COMPUTED: {
      title: '{campaignId} - Fine generazione Seed Target',
      text: 'Il Seed Target per la campagna {campaignId} è stato generato!'
    },
    SEED_TARGET_ERROR: {
      title: '{campaignId} - Fine generazione Seed Target',
      text: 'La generazione del Seed Target per la campagna {campaignId} è terminata con un errore'
    }
  },
  churnScore: {
    'at risk': 'At Risk',
    beginner: 'Beginner',
    lost: 'Lost',
    loyal: 'Loyal',
    'null': 'N/A',
    'AT RISK': 'At Risk',
    BEGINNER: 'Beginner',
    LOST: 'Lost',
    LOYAL: 'Loyal',
    'NULL': 'N/A'
  },
  departments: {
    AFTER_SALES: 'After Sales',
    SALES: 'Sales'
  },
  country: {
    AT: 'Austria',
    BE: 'Belgio',
    BG: 'Bulgaria',
    CH: 'Svizzera',
    CY: 'Cipro',
    CZ: 'Repubblica Ceca',
    DE: 'Germania',
    DK: 'Danimarca',
    EE: 'Estonia',
    ES: 'Spagna',
    FI: 'Finlandia',
    FR: 'Francia',
    GR: 'Grecia',
    HR: 'Croazia',
    HU: 'Ungheria',
    IE: 'Irlanda',
    IS: 'Islanda',
    IT: 'Italia',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Lussemburgo',
    LV: 'Lettonia',
    MT: 'Malta',
    NL: 'Olanda',
    NO: 'Norvegia',
    PL: 'Polonia',
    PT: 'Portogallo',
    RO: 'Romania',
    RS: 'Serbia',
    SE: 'Svezia',
    SI: 'Slovenia',
    SK: 'Slovacchia',
    TR: 'Turchia',
    UK: 'Regno Unito'
  },
  operator: {
    AND: 'E',
    OR: 'O',
    and: 'e',
    or: 'o'
  },
  operators: {
    eq: 'È',
    gte: 'È dopo / maggiore di',
    in: 'È uno tra',
    isnull: 'È vuoto',
    isnotnull: 'Non è vuoto',
    lte: 'È prima / minore di',
    ne: 'Non è',
    notin: 'Non è tra',
    AND: 'Tutte le condizioni (AND)',
    OR: 'Almeno una condizione (OR)',
    NOT: 'Non soddisfa la condizione (NOT)'
  },

  queryBuilder: {
    bookmarks: 'Segnalibri',
    deleteBookmark: {
      title: 'Cancella segnalibro',
      message: 'Confermare la cancellazione del segnalibro?'
    },
    dropHereToAdd: 'Lascia qui per aggiungere',
    import: 'Importa',
    delete: 'Cancella',
    fullSentence: {
      exclude: 'Escludi <strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator} <strong>{value}</strong>',
      excludeWithGroupOperator: 'Escludi <strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator} <strong>{value}</strong>, {groupOperator}',
      include: '<strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator} <strong>{value}</strong>',
      includeWithGroupOperator: '<strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator} <strong>{value}</strong>, {groupOperator}'
    },
    noBookmark: 'Nessun bookmark trovato a sistema',
    noValueSentence: {
      exclude: 'Escludi <strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator}',
      excludeWithGroupOperator: 'Escludi <strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator}, {groupOperator}',
      include: '<strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator}',
      includeWithGroupOperator: '<strong>{entity}</strong> il cui <strong>{attribute}</strong> {operator}, {groupOperator}'
    },
    eq: 'è',
    gte: 'è dopo / maggiore di',
    lte: 'è prima / minore di',
    ne: 'non è',
    in: 'è uno tra',
    isnull: 'è vuoto',
    isnotnull: 'non è vuoto',
    notin: 'non è tra'
  },
  leadType: {
    lead: 'Lead',
    permission: 'Permission'
  },
  privacy: {
    G: 'Grant',
    F: 'Forbidden',
    U: 'Unknown'
  }
}
